import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { API } from 'aws-amplify';
import { MenuItem, MessageService, SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { SignaturePad } from 'angular2-signaturepad';
import { RehabBudgetComponent } from 'src/app/rehab-budget/rehab-budget.component';

@Component({
  selector: 'app-loan-application-read-only',
  templateUrl: './loan-application-read-only.component.html',
  styleUrls: ['./loan-application-read-only.component.scss'],
  providers: [MessageService]
})
export class LoanApplicationReadOnlyComponent implements OnInit {

  @ViewChild('sigpad1') loanInfoGuarantorSignaturePad: SignaturePad;
  @ViewChild('sigpad2') ackAgreementGuarantorSignaturePad: SignaturePad;
  @ViewChild('sigpad3') borrowerAuthorizationGuarantorSignaturePad: SignaturePad;
  @ViewChild('sigpad4') ecoaGuarantorSignaturePad: SignaturePad;
  @ViewChild('sigpad5') nonOwnerOccupancyGuarantorSignaturePad: SignaturePad;
  @ViewChild(RehabBudgetComponent) rehabBudget: RehabBudgetComponent;

  app: any;
  email: string;
  applicationId: string;
  applicationForm: FormGroup;
  signaturePadOptions: Object = {
    'minWidth': 2,
    'canvasWidth': 1500,
    'canvasHeight': 150
  };
  
  exitStrategy: SelectItem[];
  propertyType: SelectItem[];
  mortgageType: SelectItem[];
  programType: SelectItem[];
  loanTerm: SelectItem[];  
  states: SelectItem[];
  yesno: SelectItem[];
  ownOrRent: SelectItem[];
  entityType: SelectItem[];
  do_not_furnish_info
  subscription: Subscription;
  
  constructor(private messageService: MessageService, 
    private route: ActivatedRoute, private router: Router,
    private formBuilder: FormBuilder) { }

  async ngOnInit() {
    this.applicationForm = this.formBuilder.group({
      ReferralName: [''],
      LoanOfficer: [''],
      HowDidYouHear: [''],
      EntityName: [''],
      EntityType: [''],
      EINNumber: [''],
      PersonalFirstName: [''],
      PersonalLastName: [''],
      PersonalBirthDate: [''],
      PersonalSSN: [''],
      PersonalPrimaryResidence: [''],
      PersonalCity: [''],
      PersonalState: [''],
      PersonalZip: [''],
      PersonalOwnOrRent: [''],
      PersonalOwnOrRentNumberOfYears: [''],
      PersonalPhone: [''],
      PersonalEmail: [''],
      ExperienceRehab: [''],
      ExperienceRental: [''],
      ExperienceProofOwnership: [''],
      SeekingPreApprovalOnly: [false],
      NoSubjectProperty: [false],
      UnderContract: [false],
      SubjectPropertyAddress: [''],
      SubjectCity: [''],
      SubjectState: [''],
      SubjectZip: [''],
      PropertyExitStrategy: [''],
      SubjectPropertyType: [''],
      LoanProgramType: [''],
      MortgageType: [''],
      PurchasePrice: [''],
      LoanTermMonths: [''],
      RehabCost: [''],
      AfterRepairValue: [''],
      RefinanceOriginalPurchasePrice: [''],
      RefinanceCurrentPayoff: [''],
      RefinanceDateAcquired: [''],
      RefinancePaymentAmount: [''],
      RefinanceMortgageLender: [''],
      RefinanceContactName: [''],
      RefinanceMortgageEmail: [''],
      RefinancePhone: [''],
      LoanInfoSignature: [''],
      LoanInfoSignatureDate: [''],
      LeasedMonthlyRent: [''],
      LeasedExpiration: [''],
      LeaseMonthToMonth: [false],
      LeasedYearlyTaxes: [''],
      LeasedYearlyInsurance: [''],
      LeasedYearlyHOADues: [''],
      LeasedHOAContact: [''],
      InteriorContact: [''],
      InteriorContactRelationship: [''],
      InteriorContactEmail: [''],
      InteriorContactPhone: [''],
      ContactTitleCompanyName: [''],
      ContactTitleContactName: [''],
      ContactTitleEmail: [''],
      ContactTitlePhone: [''],
      HOAContactName: [''],
      HOARelationship: [''],
      HOAContactEmail: [''],
      HOAPhone: [''],
      DeclarationsJudgements: [''],
      DeclarationsBankrupt: [''],
      DeclarationsForeclosed: [''],
      DeclarationsLawsuit: [''],
      DeclarationsCriminalOffense: [''],
      DeclarationsDelinquent: [''],
      DeclarationsUSCitizen: [''],
      DeclarationsPermanentResident: [''],
      DeclarationsObligatedForeclosure: [''],
      DeclarationsExplanations: [''],
      DoNotFurnishPersonalInfo: [false],
      SexMale: [false],
      SexFemale: [false],
      HispanicLatino: [false],
      NotHispanicLatino: [false],
      Indian: [false],
      AfricanAmerican: [false],
      White: [false],
      Asian: [false],
      Hawaiian: [false],
      AckAgreementPrintedName: [''],
      AckAgreementDate: [''],
      AckAgreementSignature: [''],
      BorrowerAuthPrintedName: [''],
      BorrowerAuthSignatureDate: [''],
      BorrowerAuthSignature: [''],
      ECOAPrintedName: [''],
      ECOASignatureDate: [''],
      ECOASignature: [''],
      NonOwnerOccupancyPrintedName: [''],
      NonOwnerOccupancySignatureDate: [''],
      NonOwnerOccupancySignature: [''],
      NonOwnerOccupancyEntity: [''],
      Partner1FirstName: [''],
      Partner1LastName: [''],
      Partner1Birthdate: [''],
      Partner1SSN: [''],
      Partner1PrimaryResidence: [''],
      Partner1Phone: [''],
      Partner1Email: [''],
      Partner1Ownership: [''],
      Partner2FirstName: [''],
      Partner2LastName: [''],
      Partner2Birthdate: [''],
      Partner2SSN: [''],
      Partner2PrimaryResidence: [''],
      Partner2Phone: [''],
      Partner2Email: [''],
      Partner2Ownership: [''],
      SubmissionAcknowledgement: [false],

      RehabBudget: ['']
    })

    this.populateDropDownSelections();
    
    this.subscription = this.route.queryParams.subscribe(async params => {
      if (params['email'] && params['id']) {
        this.email = params['email'];
        this.applicationId = params['id'];
        await this.getSpecificApplicationData();
        
        this.router.navigate([], { queryParams: {} });
      }
      else {
        this.router.navigate(['/dashboard']);
      }
    });
  }

  async getSpecificApplicationData() {
    const params = {
      body: {
        email: this.email,
        id: this.applicationId
      }
    }

    var applicationResponse = await API.post('ckprivateapi', '/api/get-specific-application', params);

    if (applicationResponse.success) {
      if (applicationResponse.application) {
        this.app = applicationResponse.application
        Object.keys(this.app.Application).forEach(key => {
          if (this.applicationForm.get(key)) {

            //If it's a date convert to date object
            if (typeof this.app.Application[key] === 'string' && this.isDate(this.app.Application[key])) {
              this.app.Application[key] = new Date(this.app.Application[key]);
            }

            this.applicationForm.get(key).setValue(this.app.Application[key]);
          }
        });

        this.ackAgreementGuarantorSignaturePad.fromDataURL(this.app.Application.AckAgreementSignature);
        this.borrowerAuthorizationGuarantorSignaturePad.fromDataURL(this.app.Application.BorrowerAuthSignature);
        this.ecoaGuarantorSignaturePad.fromDataURL(this.app.Application.ECOASignature);
        this.loanInfoGuarantorSignaturePad.fromDataURL(this.app.Application.LoanInfoSignature);
        this.nonOwnerOccupancyGuarantorSignaturePad.fromDataURL(this.app.Application.NonOwnerOccupancySignature);
        //this.applicationForm = this.formBuilder.group(this.app.Application);
        this.subscription.unsubscribe();
      }
      else {
        this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'This application was not found'});
      }
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'error', detail: applicationResponse.message});
    }
  }

  isDate(value) {
    const date = new Date(value);
    return !isNaN(date.getTime()) && !/[a-z]/i.test(value.replace(/[TZ]/g, ''));
  }

  populateDropDownSelections() {
    this.yesno = [
      { label:'Select', value: null },
      { label:'Yes', value: 1 },
      { label:'No', value: 0 }
    ];

  this.ownOrRent = [
    { label:'Select', value: null },
    { label:'Own', value: "Own" },
    { label:'Rent', value: "Rent" }
  ];

  this.entityType = [
    { label:'Select', value: null },
    { label:'LLC', value: "LLC" },
    { label:'Corporation', value: "C-Corporation" }
  ];

  this.propertyType = [
    { label:'Select', value: null },
    { label:'2-4 Unit', value: "2-4 Unit" },
    { label:'5-50 Unit', value: "5-50 Unit" },
    { label:'Condominium', value: "Condominium" },
    { label:'Single Family', value: "Single Family" }
  ];

  this.mortgageType = [
    { label:'Select', value: null },
    { label:'Purchase', value: "Purchase" },
    { label:'Purchase + Rehab', value: "Purchase + Rehab" },
    { label:'Purchase - Rental Finance', value: "Purchase - Rental Finance" },
    { label:'Refinance - Rental Finance', value: "Refinance - Rental Finance" },
    { label:'Refinance + Rehab', value: "Refinance + Rehab" },
    { label:'Refinance - Bridge', value: "Refinance - Bridge" }
  ];

  this.programType = [
    { label:'Select', value: null },
    { label:'Purchase', value: "Purchase" },
    { label:'Refinance', value: "Refinance" }
  ];

  this.exitStrategy = [
    { label:'Select', value: null },
    { label:'Improve & Sell', value: "Improve & Sell" },
    { label:'Long-term Hold', value: "Long-term Hold" }
  ];

  this.loanTerm = [
    { label:'Select', value: null },
    { label:'6 Month', value: 6 },
    { label:'12 Month', value: 12 },
    { label:'24 Month', value: 24 },
    { label:'5 Year', value: 60 },
    { label:'10 Year', value: 120 },
    { label:'15 Year', value: 180 },
    { label:'30 Year', value: 360 },
  ];

  this.states = [
    { label:'Select', value: null },
    { label:'Alabama', value: "AL" },
    { label:'Alaska', value: "AK" },
    { label:'Arizona', value: "AZ" },
    { label:'Arkansas', value: "AR" },
    { label:'California', value: "CA" },
    { label:'Colorado', value: "CO" },
    { label:'Connecticut', value: "CT" },
    { label:'Delaware', value: "DE" },
    { label:'Florida', value: "FL" },
    { label:'Georgia', value: "GA" },
    { label:'Hawaii', value: "HI" },
    { label:'Idaho', value: "ID" },
    { label:'Illinois', value: "IL" },
    { label:'Indiana', value: "IN" },
    { label:'Iowa', value: "IA" },
    { label:'Kansas', value: "KS" },
    { label:'Kentucky', value: "KY" },
    { label:'Louisiana', value: "LA" },
    { label:'Maine', value: "ME" },
    { label:'Maryland', value: "MD" },
    { label:'Massachusetts', value: "MA" },
    { label:'Michigan', value: "MI" },
    { label:'Minnesota', value: "MN" },
    { label:'Mississippi', value: "MS" },
    { label:'Missouri', value: "MO" },
    { label:'Montana', value: "MT" },
    { label:'Nebraska', value: "NE" },
    { label:'Nevada', value: "NV" },
    { label:'New Hampshire', value: "NH" },
    { label:'New Jersey', value: "NJ" },
    { label:'New Mexico', value: "NM" },
    { label:'New York', value: "NY" },
    { label:'North Carolina', value: "NC" },
    { label:'North Dakota', value: "ND" },
    { label:'Ohio', value: "OH" },
    { label:'Oklahoma', value: "OK" },
    { label:'Oregon', value: "OR" },
    { label:'Pennsylvania', value: "PA" },
    { label:'Rhode Island', value: "RI" },
    { label:'South Carolina', value: "SC" },
    { label:'South Dakota', value: "SD" },
    { label:'Tennessee', value: "TN" },
    { label:'Texas', value: "TX" },
    { label:'Utah', value: "UT" },
    { label:'Vermont', value: "VT" },
    { label:'Virginia', value: "VA" },
    { label:'Washington', value: "WA" },
    { label:'West Virginia', value: "WV" },
    { label:'Wisconsin', value: "WI" },
    { label:'Wyoming', value: "WY" },
  ];
  }

}
